// Core
import { useState, useCallback, useMemo } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useParams, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

// Assets
import { apiService } from 'services/ApiService';

// Components
import PartnerEditContent from './components/ApiKeyEditContent';

const apiKeySchema = z.object({
  name: z.string().min(1),
  isActive: z.boolean(),
  partnerId: z.number().int(),
});

const ApiKeysEditEdit = () => {
  const history = useHistory();
  const { id } = useParams();

  const [errorCard, setErrorCard] = useState();

  const form = useForm({
    resolver: zodResolver(apiKeySchema),
    defaultValues: {
      name: '',
      isActive: false,
      partnerId: undefined,
    },
  });

  const { reset, handleSubmit } = form;
  
  const mutation = useMutation({
    mutationFn: async (data) => {
        return apiService.createApiKey(data);
    },
    onSuccess: (res) => {
      if (res.data === false || !(res.statusCode >= 200 && res.statusCode < 300)) {
        setErrorCard(res.message);
        return;
      }
      history.push('/api-keys');
    },
    onError: () => {
      setErrorCard('Something went wrong.');
    },
  });

  const onSubmit = (values) => {
    mutation.mutate(values);
  };

  const onError = (errors) => {
    console.log('Validation errors:', errors);
  };

  const handleDelete = useCallback(async () => {
    await apiService.deleteApiKey({id});
    reset({
      name: '',
      isActive: false,
      partnerId: undefined,
    });
    history.push('/partners');
  }, [history, id, reset]);

  return (
    <PartnerEditContent handleDelete={handleDelete} isNew={true} form={form} onSubmit={handleSubmit(onSubmit, onError)} isSubmitting={mutation.isLoading} errorCard={errorCard} />
  );
};

export default ApiKeysEditEdit;